/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SchemasCustomCalcSimResultData } from './SchemasCustomCalcSimResultData';
import {
    SchemasCustomCalcSimResultDataFromJSON,
    SchemasCustomCalcSimResultDataFromJSONTyped,
    SchemasCustomCalcSimResultDataToJSON,
    SchemasCustomCalcSimResultDataToJSONTyped,
} from './SchemasCustomCalcSimResultData';
import type { SupportInfoData } from './SupportInfoData';
import {
    SupportInfoDataFromJSON,
    SupportInfoDataFromJSONTyped,
    SupportInfoDataToJSON,
    SupportInfoDataToJSONTyped,
} from './SupportInfoData';
import type { SimTableData } from './SimTableData';
import {
    SimTableDataFromJSON,
    SimTableDataFromJSONTyped,
    SimTableDataToJSON,
    SimTableDataToJSONTyped,
} from './SimTableData';
import type { DischargeInfoData } from './DischargeInfoData';
import {
    DischargeInfoDataFromJSON,
    DischargeInfoDataFromJSONTyped,
    DischargeInfoDataToJSON,
    DischargeInfoDataToJSONTyped,
} from './DischargeInfoData';

/**
 * カスタム計算結果の応答
 * @export
 * @interface CustomCalcResultResponse
 */
export interface CustomCalcResultResponse {
    /**
     * 観測所ID
     * @type {string}
     * @memberof CustomCalcResultResponse
     */
    id: string;
    /**
     * シミュレーション結果データ
     * @type {Array<SchemasCustomCalcSimResultData>}
     * @memberof CustomCalcResultResponse
     */
    simResult: Array<SchemasCustomCalcSimResultData>;
    /**
     * シミュレーション集計データ
     * @type {SimTableData}
     * @memberof CustomCalcResultResponse
     */
    simTable?: SimTableData;
    /**
     * ダム支援情報
     * @type {Array<SupportInfoData>}
     * @memberof CustomCalcResultResponse
     */
    supportInfo?: Array<SupportInfoData>;
    /**
     * 放流情報
     * @type {DischargeInfoData}
     * @memberof CustomCalcResultResponse
     */
    dischargeInfo?: DischargeInfoData;
    /**
     * アラートテキスト
     * @type {string}
     * @memberof CustomCalcResultResponse
     */
    alertTxt?: string;
}

/**
 * Check if a given object implements the CustomCalcResultResponse interface.
 */
export function instanceOfCustomCalcResultResponse(value: object): value is CustomCalcResultResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('simResult' in value) || value['simResult'] === undefined) return false;
    return true;
}

export function CustomCalcResultResponseFromJSON(json: any): CustomCalcResultResponse {
    return CustomCalcResultResponseFromJSONTyped(json, false);
}

export function CustomCalcResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomCalcResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'simResult': ((json['sim_result'] as Array<any>).map(SchemasCustomCalcSimResultDataFromJSON)),
        'simTable': json['sim_table'] == null ? undefined : SimTableDataFromJSON(json['sim_table']),
        'supportInfo': json['support_info'] == null ? undefined : ((json['support_info'] as Array<any>).map(SupportInfoDataFromJSON)),
        'dischargeInfo': json['discharge_info'] == null ? undefined : DischargeInfoDataFromJSON(json['discharge_info']),
        'alertTxt': json['alert_txt'] == null ? undefined : json['alert_txt'],
    };
}

export function CustomCalcResultResponseToJSON(json: any): CustomCalcResultResponse {
    return CustomCalcResultResponseToJSONTyped(json, false);
}

export function CustomCalcResultResponseToJSONTyped(value?: CustomCalcResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sim_result': ((value['simResult'] as Array<any>).map(SchemasCustomCalcSimResultDataToJSON)),
        'sim_table': SimTableDataToJSON(value['simTable']),
        'support_info': value['supportInfo'] == null ? undefined : ((value['supportInfo'] as Array<any>).map(SupportInfoDataToJSON)),
        'discharge_info': DischargeInfoDataToJSON(value['dischargeInfo']),
        'alert_txt': value['alertTxt'],
    };
}

